module.exports = __webpack_public_path__ + "static/media/img1-5.430d51ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/biosense/diff/img1-5.png
// module id = 1524
// module chunks = 3